import { useEffect, useState } from 'react'
import ws from '@/services/ws'
import Tooltip from 'src/shared/Common/Tooltip'

/**
 * Индикатор для отображения проблем с установлением ws соединения
 */
const WSConnectionIndicator = () => {
  const [connected, setConnected] = useState(true)
  const [showError, setShowError] = useState(false)

  useEffect(() => {
    ws.connected$.subscribe(setConnected, true)
  }, [])

  // показываем ошибку через 3 секунды после обрыва соединения (для установки начального соединения
  // или на случай если соединение тут же восстановилось)
  useEffect(() => {
    if (connected) return setShowError(false)

    const timer = setTimeout(() => setShowError(true), 3000)
    return () => clearTimeout(timer)
  }, [connected])

  return (
    <Tooltip position="bottom" text={connected ? 'Соединение с сервером установлено' : 'Ошибка подключения к серверу'}>
      <div
        className="inline-flex-gap gap8 center"
        style={{
          padding: '4px 8px',
          border: '1px solid var(--border-color)',
          borderRadius: '16px',
          cursor: 'help',
        }}
      >
        <div
          style={{
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            background: showError ? 'var(--error)' : 'var(--success)',
          }}
        />
        <p className="text-sm text-default">{connected ? 'Онлайн' : 'Оффлайн'}</p>
      </div>
    </Tooltip>
  )
}

export default WSConnectionIndicator
